module.exports = __webpack_public_path__ + "static/media/bckHome.c2898a47.svg";